import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function BonusGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const scrollToIndex = (index: number) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth;
      scrollRef.current.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const cardWidth = scrollRef.current.offsetWidth;
      const newIndex = Math.round(scrollLeft / cardWidth);
      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        const nextIndex = (activeIndex + 1) % bonuses.length;
        scrollToIndex(nextIndex);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [activeIndex, isAutoPlaying]);
  const bonuses = [{
    id: 1,
    title: 'Pisos 3D',
    description: 'Aprendé a crear superficies impactantes con profundidad y realismo extremo.',
    image: 'https://cdn.magicpatterns.com/uploads/4rTV6G7ni6u3gPY92pC2XL/Bonus_1-_Pisos_3D.webp',
    originalPrice: '$14.990'
  }, {
    id: 2,
    title: 'Resina Epóxica Tienda',
    description: 'Guía para montar tu propio showroom o tienda online de piezas de lujo.',
    image: 'https://cdn.magicpatterns.com/uploads/9d11qSV7Ba9aQ5dgvAojCS/Bonus_2-Resina_Epoxica_Tienda.webp',
    originalPrice: '$12.990'
  }, {
    id: 3,
    title: 'Artesanías',
    description: 'Secretos para fabricar objetos de decoración pequeños con acabados perfectos.',
    image: 'https://cdn.magicpatterns.com/uploads/nsU84ZihUtxj4JhHNbHcRM/Bonus_3-Artesanias.webp',
    originalPrice: '$12.990'
  }, {
    id: 4,
    title: 'Bijou',
    description: 'Dominá la joyería artesanal: anillos, colgantes y aros con encapsulados únicos.',
    image: 'https://cdn.magicpatterns.com/uploads/xhChELjGXsuRFiRkGDNRCB/Bonus_4-_Bijou.webp',
    originalPrice: '$14.990'
  }, {
    id: 5,
    title: 'Fundas para Celulares',
    description: 'Personalizá accesorios tecnológicos con diseños modernos y resistentes.',
    image: 'https://cdn.magicpatterns.com/uploads/8DhXP52UyfFwy8CkshaPvZ/Bonus_5-_Fundas_para_celulalres.webp',
    originalPrice: '$12.990'
  }, {
    id: 6,
    title: 'Pisos de Porcelanatos',
    description: 'Aprendé a aplicar porcelanato líquido para lograr acabados de lujo en pisos y grandes superficies.',
    image: 'https://cdn.magicpatterns.com/uploads/9NXmy1MiJecQshzv5tVkyJ/Bonus_6-_Pisos_de_porcelanatos.webp',
    originalPrice: '$12.990'
  }];
  // Calculate total value
  const totalValue = bonuses.reduce((sum, bonus) => {
    const price = parseInt(bonus.originalPrice.replace(/[$.]/g, ''));
    return sum + price;
  }, 0);
  return <section className="py-12 px-4 relative z-10 bg-[#fdf8f3] overflow-hidden border-y border-gray-200" data-id="element-25" data-mp="3fjhzop0fwhfo">
      <div className="max-w-7xl mx-auto" data-id="element-26" data-mp="3amritzgt9ht7">
        <div className="text-center mb-16" data-id="element-27" data-mp="35m3lyx5wi6r2">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-gray-200 text-[#d97706] text-sm font-bold mb-6 tracking-wide" data-id="element-28" data-mp="35lc04e23vndz">
            🎁 OFERTA POR TIEMPO LIMITADO
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 tracking-tight leading-[1.1]" data-id="element-29" data-mp="11yjxep9assso">
            BONUS EXCLUSIVOS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl max-w-2xl mx-auto font-normal mb-4 text-[#1A1C20]" data-id="element-30" data-mp="j4y0hnb031gn">
            Llevate estos 6 ebooks GRATIS con tu compra de hoy
          </motion.p>
        </div>

        {/* Bonus Carousel Container */}
        <div className="relative group/carousel" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)} data-id="element-31" data-mp="3hrdfdbxwz673">
          {/* Navigation Arrows */}
          <div className="absolute top-1/2 -left-2 md:-left-12 -translate-y-1/2 z-20 block" data-id="element-32" data-mp="3qslbpogvdwyj">
            <button onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(Math.max(0, activeIndex - 1));
          }} disabled={activeIndex === 0} className={`p-3 rounded-full bg-[#130a2a] border border-[#27272a] text-white transition-all ${activeIndex === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-[#1a1135] hover:border-[#f5c518] hover:text-[#f5c518]'}`} aria-label="Anterior" data-id="element-33" data-mp="3mo3w81hjm5tk">
              <ChevronLeft className="w-6 h-6" data-id="element-34" data-mp="nb34nj8x8tz6" />
            </button>
          </div>

          {/* Navigation Arrows */}
          <div className="absolute top-1/2 -right-2 md:-right-12 -translate-y-1/2 z-20 block" data-id="element-35" data-mp="i9dsu1dvkca1">
            <button onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(Math.min(bonuses.length - 1, activeIndex + 1));
          }} disabled={activeIndex === bonuses.length - 1} className={`p-3 rounded-full bg-[#130a2a] border border-[#27272a] text-white transition-all ${activeIndex === bonuses.length - 1 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-[#1a1135] hover:border-[#f5c518] hover:text-[#f5c518]'}`} aria-label="Siguiente" data-id="element-36" data-mp="3c1c26f3krasw">
              <ChevronRight className="w-6 h-6" data-id="element-37" data-mp="8m6orkaqy6mf" />
            </button>
          </div>

          {/* Scrollable Area */}
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-6 pb-8" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-38" data-mp="cna322d5bulj">
            {bonuses.map((bonus, index) => <div key={bonus.id} className="min-w-full md:min-w-[calc(50%-12px)] lg:min-w-[calc(33.333%-16px)] snap-center" data-id="element-39" data-mp="26y02mnuai160" data-mpi={index}>
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="h-full bg-white border border-gray-200 rounded-3xl p-6 md:p-8 hover:border-[#d97706]/30 transition-all duration-500 hover:shadow-[0_20px_60px_rgba(217,119,6,0.1)] group flex flex-col" data-id="element-40" data-mp="1x6vm3joyu892">
                  {/* Bonus Badge */}
                  <div className="inline-flex self-start items-center gap-2 px-3 py-1 rounded-full bg-[#d97706]/10 border border-[#d97706]/30 text-[#d97706] text-xs font-bold mb-4 tracking-wider" data-id="element-41" data-mp="10faa6g4m3b3x">
                    BONUS {bonus.id}
                  </div>

                  {/* Title */}
                  <h3 className="text-gray-900 font-bold text-xl md:text-2xl mb-3 leading-tight group-hover:text-[#d97706] transition-colors" data-id="element-42" data-mp="2ql6ncx0pgjnw">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 text-[15px] md:text-base mb-6 leading-relaxed flex-grow" data-id="element-43" data-mp="3jax3tcpt7xn6">
                    {bonus.description}
                  </p>

                  {/* Book Image */}
                  <div className="relative mb-6 overflow-hidden rounded-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-44" data-mp="39h6kem8jidec">
                    <img src={bonus.image} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-45" data-mp="61sjl5lyqlif" />
                  </div>

                  {/* Pricing */}
                  <div className="text-center mt-auto" data-id="element-46" data-mp="24c9e86zo1ud8">
                    <p className="text-gray-500 text-sm font-medium mb-2" data-id="element-47" data-mp="24ayeqjd978rx">
                      VALOR NORMAL:
                    </p>
                    <p className="text-2xl text-gray-600 line-through font-bold decoration-red-500/60 decoration-4 mb-3" data-id="element-48" data-mp="1ckaagyga9na1">
                      {bonus.originalPrice} ARS
                    </p>
                    <div className="bg-gradient-to-r from-[#f5c518] to-[#d97706] text-black font-black text-xl py-3 px-6 rounded-xl uppercase tracking-wide" data-id="element-49" data-mp="1ll04bwlzh3l4">
                      GRATIS HOY
                    </div>
                  </div>
                </motion.div>
              </div>)}
          </div>

          {/* Indicator Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-50" data-mp="2s0snaoqjib6d">
            {bonuses.map((_, index) => <button key={index} onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(index);
          }} className={`h-2 rounded-full transition-all duration-300 ${activeIndex === index ? 'w-8 bg-[#f5c518]' : 'w-2 bg-[#27272a] hover:bg-[#3f3f46]'}`} aria-label={`Ir al bonus ${index + 1}`} data-id="element-51" data-mp="28abbwv29o5kk" data-mpi={index} />)}
          </div>
        </div>
      </div>
    </section>;
}